<p-button
  [pTooltip]="tooltip | translate"
  [tooltipOptions]="tooltipOptions" 
  [disabled]="disabled"
  (click)="click($event)"
  [label]="label | translate"
  [styleClass]="getButtonClasses()"
  [iconPos]="iconPos"
  [ngClass]="getAdditionalClasses()">

  <!-- icon -->
  <ng-template
    *ngIf="icon"
    pTemplate="icon">
    <i
      [ngClass]="icon">
    </i>
    <span
      *ngIf="getBadgeValue()"
      class="badge">{{getBadgeValue()}}</span>
  </ng-template>
  <p-menu    
    #menu     
    [model]="menuItems" 
    [popup]="true"
    [appendTo]="'body'">
    <ng-template
      pTemplate="item" 
      let-item>
      <div class="flex flex-col">
        <div class="flex flex-row h-[20px]">
          <div *ngIf="item?.icon"><i class="relative top-[-6px] left-[-4px] text-[22px]" [ngClass]="item?.icon"></i></div>
          <div class="label" [ngClass]="{'ml-2': item?.icon}">{{item?.label | translate}}</div>
        </div>
      </div>
    </ng-template>
    <ng-template
      *ngIf="menuEndTemplate"
      pTemplate="end">
      <ng-template
      *ngTemplateOutlet="menuEndTemplate">
      </ng-template>
    </ng-template>
    <ng-template
      *ngIf="menuEndContent"
      pTemplate="end">
      <div class="pl-3 py-1 text-[#848488] font-light leading-3">
        {{menuEndContent | translate}}
      </div>
    </ng-template>
  </p-menu>

</p-button>  

<!-- (onShow)="onMenuShow()"
(onHide)="onMenuHide()" -->